import { AccessType } from 'app/auth/accessControlService'
import TeamMembers from './teamMembers/TeamMembers'
import RolesPermissions from './rolesPermissions/RolesPermissions'
import { Routes } from 'app/services/routeService/routeService'
import appConfigs from 'app/configs/appConfigs'
import ManageChannels from './manageChannels/ManageChannels'

import InitialNotification from './initialNotification/InitialNotification'

export const SettingsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.manageChannels(),
      component: ManageChannels,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.teamMembers(),
      component: TeamMembers,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: '/settings/roles-permissions',
      component: RolesPermissions,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: '/settings/initial-notification',
      component: InitialNotification,
      accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
    },
  ].filter(
    (route) =>
      appConfigs.isSocialPostingEnabled ||
      route.path !== Routes.socialMediaIntegrations(),
  ),
}
